module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/en_shikoku-6afad84332ce4a34d31fec5b455823fd.jpg";